import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { find } from 'lodash';
import {
  withStyles,
  withMobileDialog,
  Typography,
  Grid,
  Checkbox,
  Card,
  CardHeader,
  CardContent,
} from '@material-ui/core';
import { getDashboards } from '@pingum/app-state-management/dashboard/actions';
import styles from './styles';

import StatusBadge from '../../../widgets/StatusBadge';
import DisplayMessage from '../../../widgets/DisplayMessage';
import TagList from '../../../widgets/TagList';

export const getDashboardSearchText
  = (searchText) => ((searchText && searchText.length > 0)
    ? searchText
    : 'None');

export const getStatuses = (classes, statusIds, statuses, dashboardId) => ((statusIds || []).length === 0
  ? (
    'All statuses'
  )
  : (statusIds || []).map((statusId) => {
    const status
      = statuses.filter((checkStatus) => checkStatus.id === statusId).length > 0

        ? statuses.filter((checkStatus) => checkStatus.id === statusId)[0]
        : undefined;
    return (
      status
        ? (
          <StatusBadge
            key={`status-${dashboardId}-${status.id}`}
            className={classes.statusBadge}
            icon={status.icon}
            iconColor={status.iconColor}
          />
        )
        : '');
  }));

export const getColorForItem = (itemList, elementId) => {
  const item = itemList.filter((i) => i.id === elementId)[0];
  return item === undefined
    ? '#757575'
    : item.iconColor;
};

export const getIconForItem = (itemList, elementId) => {
  const item = itemList.filter((i) => i.id === elementId)[0];
  return item === undefined
    ? 'error'
    : item.icon;
};

export const getTags = (classes, tagGroups, tags, tagTypes, dashboardId) => (tagGroups.length === 0
  ? 'All tags'
  : tagGroups.map((tagGroup) => (
    <span key={`tagGroup-${tagGroup}-${dashboardId}`}>
      <TagList tags={tagGroup.map((tagId) => find(tags, { id: tagId })).filter((tag) => !!tag)} />
    </span>
  )));

export const buildDashboardItem
  = (
    classes,
    dashboard,
    eventSubscription,
    isEditingEventSubscription,
    statuses,
    tags,
    tagTypes,
    handleChangeSubscription,
    fullScreen,
  ) => (
    <Grid container spacing={1} alignItems="center" key={dashboard.id} name="dashboard-item" className={classes.dashboardItem}>
      <Grid item sm={10} md={3}>
        <Typography variant="h4">
          {dashboard.name}
        </Typography>
        {
            (dashboard.dashboardData.searchText
                && dashboard.dashboardData.searchText.length > 0)
                && (
                  <Typography variant="caption">
                    Search Term Filter: { getDashboardSearchText(dashboard.dashboardData.searchText) }
                  </Typography>
                )
          }
      </Grid>
      {
        !fullScreen
          && (
            <Grid item sm={4}>
              {getStatuses(classes, dashboard.dashboardData.statusIds, statuses, dashboard.id)}
            </Grid>
          )
      }
      {
        !fullScreen
          && (
            <Grid item md={4}>
              {getTags(classes, dashboard.dashboardData.tagConditions, tags, tagTypes, dashboard.id)}
            </Grid>
          )
      }
      <Grid item xs={1}>
        <Checkbox
          checked={eventSubscription.dashboards.indexOf(dashboard.id) >= 0}
          onChange={handleChangeSubscription}
          value={dashboard.id}
          disabled={isEditingEventSubscription}
        />
      </Grid>
    </Grid>
  );

export class DashboardSubscriptionsCardComponent extends React.Component {
  constructor(props) {
    super(props);

    this.props.getDashboards();
  }

  handleChangeSubscription = (event) => {
    const dashboardId = event.target.value;
    if (this.props.eventSubscription.dashboards.indexOf(parseInt(dashboardId, 10)) >= 0) {
      // remove subscription
      this.props.updateEventSubscription(this.props.profile.user_id, { dashboards: { remove: [dashboardId] } });
    }

    // add subscription
    this.props.updateEventSubscription(this.props.profile.user_id, { dashboards: { add: [dashboardId] } });
  }

  render() {
    const {
      classes,
      dashboards,
      isEditingEventSubscription,
      statuses,
      tags,
      tagTypes,
      eventSubscription,
      isFetching,
      fullScreen,
    } = this.props;

    if (isFetching) {
      return <div />;
    }

    return (
      <div className={classes.root}>
        <Card>
          <CardHeader
            title="Private Dashboards"
            subheader="Dashboards only you can see and use"
          />
          <CardContent>
            {
              dashboards.filter((d) => !d.organizationExposed).length === 0
              && (
                <DisplayMessage
                  id="no-personal-dashboards-text"
                  title="No Private Dashboards"
                  subTitle="You can create one from the dashboard or your dashboard settings page"
                  icon="info_outline"
                />
              )
            }
            {
              dashboards.filter((d) => !d.organizationExposed)
                .map((dashboard) => (
                  buildDashboardItem(
                    classes,
                    dashboard,
                    eventSubscription,
                    isEditingEventSubscription,
                    statuses,
                    tags,
                    tagTypes,
                    this.handleChangeSubscription,
                    fullScreen,
                  )
                ))
            }
          </CardContent>
        </Card>

        <Card>
          <CardHeader
            title="Shared Dashboards"
            subheader="Dashboards exposed to the entire organization"
          />
          <CardContent>
            {
              dashboards.filter((d) => d.organizationExposed).length === 0
              && (
                <DisplayMessage
                  id="no-organization-dashboards-text"
                  title="No Shared Dashboards"
                  subTitle="Your organization does not have any shared dashboards - only admins can create a shared dashboard"
                  icon="info_outline"
                />
              )
            }
            {
              dashboards.filter((d) => d.organizationExposed)
                .map((dashboard) => (
                  buildDashboardItem(
                    classes,
                    dashboard,
                    eventSubscription,
                    isEditingEventSubscription,
                    statuses,
                    tags,
                    tagTypes,
                    this.handleChangeSubscription,
                    fullScreen,
                  )
                ))
            }
          </CardContent>
        </Card>
      </div>
    );
  }
}

DashboardSubscriptionsCardComponent.propTypes = {
  profile: PropTypes.object,
  classes: PropTypes.object,
  getDashboards: PropTypes.func,
  dashboards: PropTypes.array,
  isEditingEventSubscription: PropTypes.bool,
  eventSubscription: PropTypes.object,
  updateEventSubscription: PropTypes.func,
  statuses: PropTypes.array,
  tags: PropTypes.array,
  tagTypes: PropTypes.array,
  isFetching: PropTypes.bool,
  fullScreen: PropTypes.bool,
};

DashboardSubscriptionsCardComponent.defaultProps = {
  profile: { user_id: '' },
  classes: {},
  getDashboards: () => {},
  dashboards: [],
  updateEventSubscription: () => {},
  isEditingEventSubscription: false,
  eventSubscription: {
    dashboards: [],
    eventTemplates: [],
  },
  statuses: [],
  tags: [],
  tagTypes: [],
  isFetching: true,
  fullScreen: false,
};

export const mapStateToProps = (state) => ({
  profile: state.user.user,
  dashboards: state.dashboard.dashboards.filter((d) => d.id >= 0),
  isEditingEventSubscription: state.eventSubscription.isEditingEventSubscription,
  eventSubscription: state.eventSubscription.eventSubscription,
  statuses: state.status.statuses,
  tags: state.tag.tags,
  tagTypes: state.tagType.tagTypes,
  isFetching:
    state.dashboard.isFetchingDashboards
    || state.eventSubscription.isFetchingEventSubscription,
});

export const mapDispatchToProps = (dispatch) => ({ getDashboards: () => dispatch(getDashboards()) });

export default withStyles(styles)(withMobileDialog({ breakpoint: 'sm' })(connect(
  mapStateToProps,
  mapDispatchToProps,
)(DashboardSubscriptionsCardComponent)));
